<div class="accordion rounded-pill " [ngClass]="maximized? ShowChat? 
isSelectedAgentOnCall()?'video-chat-on FullScren':'video-chat-off FullScren': 
'FullScren': ''">
  <div class="accordion-item rounded-corner shadow-b bg-primary-light">
    <h2 class="accordion-header accordion-button text-primary  p-2 box-shadow-0 chat-tittle">

      <i class="fal fa-comment-dots icon-header"></i>
      <b class="font-md">{{chatSectionLabel}}
      </b> <span class="px-1"> - </span><span class="font-md overflow-elipse" title={{AgentLanId}}
        data-bs-toggle="tooltip" data-bs-placement="top">
        {{ AgentLanId}}</span>

      <div class="additionalIconsRight">
        <div>
          <div class="minifab bgpurple" (click)="peepRequest()" *ngIf="isPeepButtonEnabled" title="{{peepLabel}}"
            data-bs-toggle="tooltip" data-bs-placement="top">
            <i class="fa-light fa-binoculars m-2 text-white"></i>
          </div>

          <div class="minifab bgpurple" (click)="screenBlock()" *ngIf="isBlockButtonEnabled"
            title="{{screenblockLabel}}" data-bs-toggle="tooltip" data-bs-placement="top">
            <i class="fa-light fa-display m-2 text-white"></i>
          </div>

          <div class="minifab bgpurple text-secondary" (click)="screenUnBlock()" *ngIf="isUnblockButtonEnabled"
            title="{{screenUnblockLabel}}" data-bs-toggle="tooltip" data-bs-placement="top">
            <i class="fa-light fa-display-slash m-2 text-white"></i>
          </div>

          <div class="minifab bgpurple text-secondary" (click)="screenGrab()" *ngIf="isScreenGrabButtonEnabled"
            title="{{screenGrabLabel}}" data-bs-toggle="tooltip" data-bs-placement="top">
            <i class="fa-light fa-image-polaroid m-2 text-white"></i>
          </div>

          <!-- <div class="minifab bgpurple text-secondary" (click)="videoAudioCall()" *ngIf="isCallButtonEnabled" title="{{callLabel}}" data-bs-toggle="tooltip" data-bs-placement="top">
          <i 
            class="fal fa-phone m-2  text-white"></i>
        </div> -->

          <div *ngIf="isBargeInButtonEnabled" class="minifab bgpurple text-secondary" (click)="selectScreenToShare()"
            title="{{bargeInLabel}}" data-bs-toggle="tooltip" data-bs-placement="top">
            <span>
              <i class="fal fa-display m-2 text-white"></i>
              <i class="fas fa-eye fa-stack-1x m-2 text-white"
                style="transform: translate(0px, 6px);margin: 0px !important;font-size: 10px;height: 100%;"></i>
            </span>
          </div>

          <div class="minifab bgpurple text-secondary " (click)="deactivateStealthMode()"
            *ngIf="showStealthDeactivateButton ? 'd-block':''">
            <i title="{{deactivateStealthModeLabel}}" data-bs-toggle="tooltip" data-bs-placement="top"
              class="fa-light fa-hood-cloak m-2 text-white"></i>
          </div>

          <div class="minifab bgpurple text-secondary" (click)=toggleChat() *ngIf="isSelectedAgentOnCall()">
            <i title="{{showChatLabel}}" data-bs-toggle="tooltip" data-bs-placement="top"
              class="m-2 text-white fal fa-comment-alt-plus" *ngIf="ShowChat === false"></i>
            <i title="{{hideChatLabel}}" data-bs-toggle="tooltip" data-bs-placement="top"
              class="m-2 text-white fal fa-comment-alt-slash" *ngIf="ShowChat === true"></i>
          </div>
        </div>

        <button type="button" class="btn" (click)=toggleMaximize() data-bs-toggle="tooltip" data-bs-placement="top"
          style="padding: 8px;" *ngIf="!(ShowChat && isSelectedAgentOnCall() && maximized)">
          <i aria-hidden="true" title="{{minimizeLabel}}" data-bs-toggle="tooltip" data-bs-placement="top"
            [ngClass]="maximized ? 'fal fa-compress-wide': '' "></i>
          <i aria-hidden="true" title="{{maximizeLabel}}" data-bs-toggle="tooltip" data-bs-placement="top"
            [ngClass]="maximized ? '': 'fal fa-expand' "></i>
        </button>

        <button type="button" class="btn" (click)="toggleCollapse()" style="padding: 8px;"
          *ngIf="!(ShowChat && isSelectedAgentOnCall() && maximized)">
          <i class="fal " [ngClass]="collapsed ? 'fa-chevron-down' : 'fa-chevron-up'"></i>
        </button>
      </div>
    </h2>

    <div class="custom-area height-235"
      [ngClass]="collapsed? 'accordion-collapse collapse hide': 'accordion-collapse collapse show'"
      aria-labelledby="panelsStayOpen-headingOne">
      <div class="accordion-body text-center bg-primary-light rounded-corner p-1">
        <div *ngIf="!violationsKeys.length" class="chat-img">
          <img *ngIf="isSupervisorChatEnabled" src="assets/images/no-data.svg" height="100px" width="100px" alt="..."
            class="img-thumbnail border-0 w-100">
          <h6 *ngIf="isSupervisorChatEnabled">{{noDataFoundLabel}}</h6>
        </div>
        <ng-container *ngIf="loading">
          {{loadingLabel}} ...
        </ng-container>
        <div class="voice-call-box h-145 b-radius" [ngClass]=" ShowChat? maximized? isSelectedAgentOnCall() ? 'eee voice-call-box-black'
      : 'yytu d-none' : 'qqq d-none' : isSelectedAgentOnCall() ? '': 'd-none'">

          <div [ngClass]="isSelectedAgentOnCall()? 'remote-video-full-screen-container': 'd-none'">
            <video #received_video [autoplay]="true" [muted]="false"
              [ngStyle]="{'height':webrtcInfoService.isCallInProgress() ? '100%':''}"
              [ngClass]="isSelectedAgentOnCall()? 'remote-video-full-screen': 'd-none'" [controls]="false">
            </video>
          </div>

          <div [ngClass]="isSelectedAgentOnCall() && callType !== 'bargeIn'? 'wrapper': 'd-none'">
            <video #local_video [autoplay]="true" [muted]="true" [controls]="false"
              [ngClass]="isSelectedAgentOnCall()? 'sm-video': 'd-none'"></video>
          </div>

          <div class="center-con text-center" [ngClass]="isSelectedAgentOnCall()? '': 'd-none'">
            <div class="info-caller float-start timeloder" *ngIf="webrtcInfoService.isCallInProgress()">
              <div class="call-timmer-bg">
                <div style="width: 20%;height: 100%;display: flex;justify-content: center;align-items: center;">
                  <i class="far fa-dot-circle" style="color: red;"></i>
                </div>
                <div style="width: 80%;height: 100%;padding-left: 5px;">
                  <div style="width: 100%;height: 50%;display: flex;justify-content: flex-start;align-items: flex-end;">
                    <span class="timmer-count ">
                      {{ callTime * 1000 | date:'H:mm:ss':'UTC'}}
                    </span>
                  </div>
                  <div
                    style="width: 100%;height: 50%;display: flex;justify-content: flex-start;align-items: flex-start;">
                    <span style="color:#603988;font-size: 16px;font-weight: bold;"> {{
                      webrtcInfoService.getCallState() }}</span>
                  </div>
                </div>
              </div>
            </div>
            <ul>
              <li *ngIf="callType !== 'bargeIn'">
                <button (click)="pauseLocalAudio()"
                  class="icon-btn button-annimate is-animating  minifab text-secondary button-effect mic mx-2"
                  data-tippy-content="Mute">
                  <i *ngIf="!LocalAudioMute" class="fa fa-volume-mute" title="{{muteAudioLabel}}"
                    data-bs-toggle="tooltip" data-bs-placement="top"></i>
                  <i *ngIf="LocalAudioMute" class="fa fa-volume-off bgpurple " title="{{unmuteAudioLabel}}"
                    data-bs-toggle="tooltip" data-bs-placement="top"></i>
                </button>
              </li>
              <li *ngIf="callType !== 'bargeIn'">
                <button class="icon-btn button-annimate is-animating
                minifab text-secondary button-effect  mic mx-2 video-call" data-tippy-content="Mute Video"
                  (click)="pauseLocalVideo()">
                  <i *ngIf="LocalVideoMute" class="fas fa-video-slash" title="{{unmuteVideoLabel}}"
                    data-bs-toggle="tooltip" data-bs-placement="top"></i>
                  <i *ngIf="!LocalVideoMute" class="fas fa-video" title="{{muteVideoLabel}}" data-bs-toggle="tooltip"
                    data-bs-placement="top"></i>
                </button>
              </li>
              <li>
                <button class="icon-btn button-annimate btn-primary button-effect btn-xl is-animating 
                  mx-2" title="changeScreenLabel" data-bs-toggle="tooltip" data-bs-placement="top"
                  *ngIf="callType === 'bargeIn' && webrtcInfoService.getScreenShareDetails().length > 1"
                  (click)="showScreenSelectionPopup()">
                  <i class="fa-solid fa-display-medical"></i>
                </button>
                <button class="icon-btn button-annimate btn-danger button-effect btn-xl is-animating 
                  mx-2" data-dismiss="modal" data-tippy-content="Hangup" title="{{endCallLabel}}"
                  data-bs-toggle="tooltip" data-bs-placement="top" (click)="closeVideoCall('end')"
                  style="background-color: red;color: white !important;">
                  <i [ngClass]="callType == 'bargeIn'? 'fa-stop': 'fa-phone-slash'" class="fas "></i>
                </button>
              </li>
            </ul>
          </div>
        </div>
        <!-- call-voice app -->

        <div data-reactroot="" [ngClass]="{
  'chatApp__room': ShowChat || !isSelectedAgentOnCall(),
  'd-none': !ShowChat && isSelectedAgentOnCall()}" *ngIf="!loading">
          <h2 class="accordion-header accordion-button p-2 box-shadow-0 chat-showheader">
            <i class="fal fa-comment-dots icon-header"></i>
            <b class="font-md">{{chatSectionLabel}} </b>
            <span class="px-1"> - </span>
            <span class="font-md"> {{AgentLanId}}</span>
          </h2>
          <div class="chatApp__conv w-100">
            <div class=" height-chat overflow-auto custom-area" #scrollChat>
              <ng-container *ngFor="let violationIndex of violationsKeys" class="text-center">
                <ng-container *ngIf="violationHistory && violationHistory[violationIndex]">

                  <div
                    *ngIf="violationHistory[violationIndex] && violationHistory[violationIndex].ActionName != null;then action else violation">
                  </div>


                </ng-container>
                <ng-template #action>
                  <div [ngSwitch]="violationHistory[violationIndex].ActionName">
                    <div *ngSwitchCase="'Screen Grab Response'">
                      <div class="text-center" (click)="showLightbox(violationIndex)">
                        <div class="col-12 px-2 py-1">
                          <div class="chat-buble hover-coursor">
                            <span class="card-text m-0 font-primary-color lh-1">
                              <i class="far fa-bell icon-header bg-bell text-white"></i>
                              <!-- 5. SCREENBLOCKAPPROVED -->
                              {{violationHistory[violationIndex].ViolationDateTime | date:'medium' }}</span>
                            <span class="text-truncate fw-bold m-0 font-primary-color">
                              Screen Grab Response</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div *ngSwitchCase="'Screen Grab Denied'">
                      <div class="text-center" (click)=showViolationDetailsPopUp(violationIndex)>
                        <div class="col-12 px-2 py-1">
                          <div class="chat-buble">
                            <span class="card-text m-0 font-primary-color lh-1">
                              <i class="far fa-bell icon-header bg-bell text-white"></i>
                              <!-- 5. SCREENBLOCKAPPROVED -->
                              {{violationHistory[violationIndex].ViolationDateTime | date:'medium' }}</span>
                            <span class="text-truncate fw-bold m-0 font-primary-color">
                              {{violationHistory[violationIndex].ActionName}}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div *ngSwitchCase="'BargeIn Denied'">
                      <div class="text-center" (click)=showViolationDetailsPopUp(violationIndex)>
                        <div class="col-12 px-2 py-1 ">
                          <div class="chat-buble">
                            <span class="card-text m-0 font-primary-color lh-1">
                              <i class="far fa-bell icon-header bg-bell text-white"></i>
                              {{violationHistory[violationIndex].ViolationDateTime | date:'medium' }}</span>
                            <span class="text-truncate fw-bold m-0 font-primary-color">
                              {{violationHistory[violationIndex].ActionName}}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div *ngSwitchCase="'Call Declined'">
                      <div class="text-center" (click)=showViolationDetailsPopUp(violationIndex)>
                        <div class="col-12 px-2 py-1 ">
                          <div class="chat-buble">
                            <span class="card-text m-0 font-primary-color lh-1">
                              <i class="far fa-bell icon-header bg-bell text-white"></i>
                              {{violationHistory[violationIndex].ViolationDateTime | date:'medium' }}</span>
                            <span class="text-truncate fw-bold m-0 font-primary-color">
                              {{violationHistory[violationIndex].ActionName}}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div *ngSwitchCase="'CHATMESSAGERECEIVED'">
                      <div class="chatApp__convMessageItem chatApp__convMessageItem--left clearfix mb-3">
                        <img src={{selectedProfilePic}} class="chatApp__convMessageAvatar">
                        <div class="w-90">
                          <h1
                            class="card-text chatApp__convMessageValue text-break font-md m-0 font-primary-color mb-3">
                            {{violationHistory[violationIndex].ChatMessage}}
                          </h1>
                          <!-- 1. Chat Message Incoming -->
                          <span class="msg_time_send_incoming">
                            {{violationHistory[violationIndex].ViolationDateTime | date:'medium'}}</span>
                        </div>
                      </div>
                    </div>
                    <div *ngSwitchCase="'CHATMESSAGE'">
                      <div class="chatApp__convMessageItem chatApp__convMessageItem--right clearfix mb-3">
                        <img src={{trsService.supervisorProfilePicture}} class="chatApp__convMessageAvatar">
                        <div class="w-100">
                          <h1
                            class="card-text chatApp__convMessageValue text-break font-md m-0 font-primary-color mb-3">
                            {{violationHistory[violationIndex].ChatMessage}}
                          </h1>
                          <!-- 2. Chat Message Outgoing -->
                          <span class="msg_time_send">{{violationHistory[violationIndex].ViolationDateTime |
                            date:'medium'}}</span>
                        </div>
                      </div>
                    </div>
                    <div *ngSwitchCase="'STEALTHMODE'">
                      <div class="text-center" (click)="showStealthModeApprovalPopUp(violationIndex)">
                        <div class="col-12 px-2 py-1">
                          <div class="chat-buble">
                            <span class="chatApp__convMessageItem m-0 font-primary-color lh-1 " [ngClass]="violationHistory[violationIndex].ChatMessage == 'STEALTH MODE REQUESTED'?
                      'hover-coursor': ''" *ngIf="violationHistory[violationIndex].ViolationDateTime"
                              data-bs-toggle="tooltip" data-bs-placement="top">
                              <i class="far fa-bell icon-header bg-bell text-white "></i>
                              <!-- 3. STEALTH MODE REQUESTED -->
                              {{ violationHistory[violationIndex].ViolationDateTime | date:'medium'
                              }}</span>
                            <span class="card-text m-0 font-primary-color fw-bold" [ngClass]="violationHistory[violationIndex].ChatMessage == 'STEALTH MODE REQUESTED'?
                        'hover-coursor': ''">
                              {{violationHistory[violationIndex].ChatMessage}}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div *ngSwitchCase="'VIOLATIONWORKFLOW'">
                      <div class="text-center">
                        <div class="col-12 px-2 py-1 ">
                          <div class="chat-buble">
                            <span class="card-text m-0 font-primary-color fw-bold lh-1" data-bs-toggle="tooltip"
                              data-bs-placement="top">
                              <i class="far fa-bell icon-header bg-bell text-white"></i>

                              <!-- 4. VIOLATIONWORKFLOW -->
                              {{violationHistory[violationIndex].ViolationDateTime | date:'medium' }}</span>

                            <span class="text-truncate m-0 font-primary-color fw-bold">
                              {{violationHistory[violationIndex].ViolationName}}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div *ngSwitchCase="'SCREENBLOCKAPPROVED'">
                      <div class="text-center">
                        <div class="col-12 px-2 py-1 ">
                          <div class="chat-buble">
                            <span class="card-text m-0 font-primary-color lh-1">
                              <i class="far fa-bell icon-header bg-bell text-white"></i>
                              <!-- 5. SCREENBLOCKAPPROVED -->
                              {{violationHistory[violationIndex].ViolationDateTime | date:'medium' }}</span>

                            <span class="text-truncate fw-bold m-0 font-primary-color">
                              Screen Block Approved</span>

                          </div>
                        </div>
                      </div>
                    </div>
                    <div *ngSwitchCase="'UNBLOCKAPPROVED'">
                      <div class="text-center">
                        <div class="col-12 px-2 py-1 ">
                          <div class="chat-buble">
                            <span class="card-text m-0 font-primary-color lh-1">
                              <i class="far fa-bell icon-header bg-bell text-white"></i>
                              <!-- 6. UNBLOCKAPPROVED -->
                              {{violationHistory[violationIndex].ViolationDateTime | date:'medium'}}</span>

                            <span class="text-truncate m-0 font-primary-color fw-bold">
                              Unblock Screen Approved</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div *ngSwitchCase="'PEEPCOMPLETE'">
                      <div class="text-center hover-coursor" (click)=showViolationDetailsPopUp(violationIndex)>
                        <div class="col-12 px-2 py-1 ">
                          <div class="chat-buble">
                            <span class="card-text m-0 font-primary-color lh-1">
                              <i class="far fa-bell icon-header bg-bell text-white"></i>
                              <!-- 7. PEEPCOMPLETE -->
                              {{violationHistory[violationIndex].ViolationDateTime | date:'medium'}}</span>

                            <span class="text-truncate m-0 font-primary-color fw-bold">
                              Check-In response received </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div *ngSwitchCase="'PEEPDENIED'">
                      <div class="text-center">
                        <div class="col-12 px-2 py-1 ">
                          <div class="chat-buble">
                            <span class="card-text m-0 font-primary-color lh-1">
                              <i class="far fa-bell icon-header bg-bell text-white"></i>
                              {{violationHistory[violationIndex].ViolationDateTime | date:'medium'}}</span>

                            <span class="text-truncate m-0 font-primary-color fw-bold">
                              {{ violationHistory[violationIndex].ViolationName }} </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div *ngSwitchCase="'ACTIONS'">
                      <div class="chatApp__convMessageItem" *ngIf="violationHistory && violationHistory[violationIndex] && 
                violationHistory[violationIndex].ShowInChat">
                        <div class="col-12 px-2 py-1" (click)=showViolationDetailsPopUp(violationIndex)>
                          <div class="chat-buble">
                            <span class="card-text m-0 font-primary-color"
                              title={{violationHistory[violationIndex].ViolationName}}>
                              <i class="far fa-bell icon-header bg-bell text-white"></i>
                              {{violationHistory[violationIndex].Time | date:'medium'}}</span>

                            <span class="text-truncate m-0 font-primary-color fw-bold">
                              {{violationHistory[violationIndex].ViolationName}}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div *ngSwitchDefault></div>
                  </div>
                </ng-template>
                <ng-template #violation>
                  <div class="chatApp__convMessageItem"
                    *ngIf="violationHistory[violationIndex] && violationHistory[violationIndex].ShowInChat">
                    <div class="col-12 px-2 py-1">
                      <div class="chat-buble"
                        *ngIf="violationHistory[violationIndex] && violationHistory[violationIndex].ShowInChat">
                        <span class="card-text m-0 font-primary-color" *ngIf="violationHistory[violationIndex] && violationHistory[violationIndex].ViolationDateTime && 
                    violationHistory[violationIndex].ViolationDateTime != 'Invalid Date' ">

                          <i class="far fa-bell icon-header bg-bell text-white "></i>
                          <!-- 9. Violation -->
                          {{ violationHistory[violationIndex].ViolationDateTime | date:'medium'
                          }}</span>

                        <span class="card-text m-0 font-primary-color fw-bold lh-1"
                          *ngIf="violationHistory[violationIndex] && violationHistory[violationIndex].ViolationName"
                          [ngClass]="violationHistory[violationIndex].ViolationName == 'Check-In response received'?
                      'hover-coursor': ''" (click)=showViolationDetailsPopUp(violationIndex)>
                          {{violationHistory[violationIndex].ViolationName}}</span>

                        <span class="card-text  font-md m-0 font-primary-color lh-1 "
                          *ngIf="violationHistory[violationIndex] && violationHistory[violationIndex].EventId">
                          {{eventIdLabel}}: {{violationHistory[violationIndex].EventId}}</span>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </ng-container>
            </div>
            <div class="chatApp__convSendMessage clearfix">
              <div class="chatApp__convTyping"></div>
              <div class="chat-controls-container">
                <emoji-mart class="" *ngIf="isEmojiPickerShown" (emojiSelect)="addEmoji($event)"
                  [darkMode]="supervisorService.selectedTheme$.value === 'dark'" [showPreview]="false"
                  [style]="{ position: 'absolute', bottom: '50px' }" title="{{emojiLabel}}" [enableSearch]="true"
                  [showPreview]="false" [emojiTooltip]="true" [hideObsolete]="true" [emojiSize]="24"
                  [isNative]="true"></emoji-mart>
                <div class="chatApp__emojiButton {{isSupervisorChatEnabled === false ? 'hidden':''}}"
                  (click)="toggleEmojiPickerVisibility()" data-bs-toggle="tooltip" data-bs-placement="top"
                  title="{{emojiLabel}}">
                  <i class="fa-solid fa-face-smile hover-coursor"></i>
                </div>
                <input type="text" class="chatApp__convInput text-break" maxlength="200"
                  id="___chat-text-input-{{AgentLanId}}" placeholder="{{sendAMessageLabel}} ({{AgentLanId}})"
                  disabled={{!isSupervisorChatEnabled}} (keydown)="onKeydown($event)" aria-label="Send"
                  aria-describedby="basic-addon2" [(ngModel)]="txtChat" tabindex="0">
                <div class="chatApp__convButton" (click)="sendChatMessage()" data-bs-toggle="tooltip"
                  data-bs-placement="top" title="{{sendAMessageLabel}}">
                  <i class="fa fa-paper-plane hover-coursor"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- chat app -->

      </div>
    </div>
  </div>

  <!-- CloseViolationsPopUpEvent: is a custom event which occurs when Popup is closed  -->
  <app-violation-approval (CloseViolationsPopUpEvent)="hideViolationDetailsPopUp($event)"
    [violationData]="violationHistory[violationIndex]" [selectedAgentLanId]="AgentLanId"
    [AgentProfilePic]="selectedProfilePic" *ngIf="showPopUp" [enableEscalate]=false>
  </app-violation-approval>

  <div class="modal" [ngStyle]="{'display':showApprovalPopUp?'block':'none'}" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-sm" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{stealthModeApprovalLabel}}</h5>
          <button type="button" class="close btn" data-dismiss="modal" (click)="hideStealthModeApprovalPopUp()"
            aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body text-center">
          <p>{{stealthModeRequestedLabel}}</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn button-primary"
            (click)="updateStealthModeActionTo(true, violationIndex)">{{allowLabel}}</button>
          <button type="button" class="btn button-danger" data-dismiss="modal"
            (click)="updateStealthModeActionTo(false, violationIndex)">{{denyLabel}}</button>
        </div>
      </div>
    </div>
  </div>
  <ng-image-fullscreen-view [images]="imageObject" [imageIndex]="selectedImageIndex" [show]="showFlag"
    (close)="closeEventHandler()"></ng-image-fullscreen-view>